import {ICurrencyService} from "./currency.service.interface";
import {action, makeObservable, observable} from "mobx";
import {Price} from "./price";
import {ServiceBase} from "../service-base";
import {IServiceFactory} from "../service-factory.interface";

export class CurrencyService extends ServiceBase implements ICurrencyService {
    constructor(services: IServiceFactory) {
        super(services)
        this.current = 'EUR'; //TODO - get the currency code from the url
        makeObservable(this, {
            current: observable.ref,
            setCurrentCurrency: action.bound,
        });
    }



    current: string;
    formatMoney(value: number): string {
       return this.formatMoneyForCurrency(value, this.current);
    }

    setCurrentCurrency(value:string) {
        this.current = value;
        this.services.localStorage.setItem('userProfile.currency', value);
    }

    formatNumber(value: number): string {
        return new Intl.NumberFormat(this.services.language.currentLanguage)
            .format(value)
            .replace('\u00A0', ' ') ;
    }

    formatMoneyForCurrency(value: number, currency: string): string {
        let formatOptions: Intl.NumberFormatOptions = {
            style: 'currency',
            currency: currency
        };

        switch (currency) {
            case 'USD':
            case 'EUR':
            case 'GBP':
                formatOptions.currencyDisplay = 'narrowSymbol';
                break;
        }

        let formattedMoney: string;
        try {
            formattedMoney = new Intl.NumberFormat(this.services.language.currentLanguage, formatOptions).format(value);
        } catch (err) {
            formattedMoney = new Intl.NumberFormat(this.services.language.currentLanguage, {
                ...formatOptions,
                currencyDisplay: 'symbol'
            }).format(value);
        }

        return formattedMoney.replace('\u00A0', ' ') ;
    }

    createPrice(amount: number, currency?: string): Price {
        return new Price(amount, currency || this.current, this);
    }

}
